
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("kpzlJ", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.5d8df0ed.js.map
